import { render, staticRenderFns } from "./banAccountByIp.vue?vue&type=template&id=a1c4c14e&"
import script from "./banAccountByIp.vue?vue&type=script&lang=js&"
export * from "./banAccountByIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1c4c14e')) {
      api.createRecord('a1c4c14e', component.options)
    } else {
      api.reload('a1c4c14e', component.options)
    }
    module.hot.accept("./banAccountByIp.vue?vue&type=template&id=a1c4c14e&", function () {
      api.rerender('a1c4c14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/components/banAccountByIp.vue"
export default component.exports